import { isIndividualUser } from '../../../utils/productAccess';

const TELECOM_COPY = {
  generationProgressStageIdentity: '핵심 변수와 통신 DNA를 조합해 고유한 정체성을 형성합니다.',
  serviceDescriptionPlaceholder:
    '제공하려는 서비스의 목적과 핵심 기능을 입력해 주세요. (예: 현재 데이터 사용 패턴을 분석해 가장 유리한 요금제를 추천받고, 앱에서 즉시 변경할 수 있는 서비스)',
  targetAudiencePlaceholder:
    '희망하는 타겟의 특징이 있다면 적어주세요. (예: 통신비 지출은 아깝지만 하나하나 비교하기엔 시간이 부족한 직장인, 복잡한 혜택보다는 확실한 요금 할인을 선호하는 유저 등)',
  segmentNamePlaceholder:
    '세그먼트를 대표하는 이름을 입력해 주세요. (예: 통신사 VIP 혜택 중시 집단, 결합 할인을 챙기는 30대 가장 등)',
  segmentDefinitionPlaceholder:
    '타겟의 주요 특징과 행동 양식을 설명해 주세요. (예: 요금제 구조에 대한 이해도가 높으나, AI 상담사의 답변은 끝까지 의심하며 직접 검색으로 교차 검증하는 꼼꼼한 성격)',
  researchGoalPlaceholder:
    "예: 해외여행을 앞두고 '로밍 요금제'와 '도시락 와이파이' 사이에서 고민 중인 유저들을 리서치하고자 함.",
  testUiNamePlaceholder:
    "테스트 이름을 입력해주세요. (예:멤버십 메인 하단 '주변 혜택' 아이콘의 직관성 및 메뉴 진입 편의성 확인)",
  testUiDescriptionPlaceholder:
    "테스트 내용을 입력해주세요. (예:신규 멤버십 바코드 노출 화면에서 유저가 제휴사 혜택을 탐색할 때, 핵심 기능인 '바코드 제시'가 최우선으로 인지되는지 검증하고자 함)",
  testAbNamePlaceholder:
    '테스트 이름을 입력해주세요. (예: 요금제 변경 시, 혜택 정보 안내 태그 디자인 및 위치의 UI 선호 비교)',
  testAbDescriptionPlaceholder:
    "테스트내용을 입력해주세요. (예:현재 요금제와 추천 요금제를 비교할 때, '이용 가능한 혜택'의 위치에 따른 유저의 만족도 및 실제 변경 완료율에 미치는 영향을 확인하고자 함)",
};

const FINANCE_COPY = {
  generationProgressStageIdentity: '핵심 변수와 투자 행동 DNA를 조합해 고유한 정체성을 형성합니다.',
  serviceDescriptionPlaceholder:
    '제공하려는 금융 서비스의 목적과 핵심 기능을 입력해 주세요. (예: 초보 투자자도 쉽게 국내·해외 주식을 매매하고, 포트폴리오 수익률을 한눈에 확인할 수 있는 증권 앱)',
  targetAudiencePlaceholder:
    '희망하는 타겟의 특징이 있다면 적어주세요. (예: 투자 경험은 적지만 관심은 많은 직장인, 복잡한 차트보다 직관적인 수익률 표시를 선호하는 초보 투자자 등)',
  segmentNamePlaceholder:
    '세그먼트를 대표하는 이름을 입력해 주세요. (예: 초보 투자자, 안정형 장기 투자 선호 집단, 모바일 중심 단기 매매 유저 등)',
  segmentDefinitionPlaceholder:
    '타겟의 투자 성향과 금융 행동을 설명해 주세요. (예: 손실 회피 성향이 강하고, 검증된 정보와 쉬운 UI를 중시하며 앱에서 빠르게 매매를 완료하려는 성격)',
  researchGoalPlaceholder:
    '예: 증권 앱 홈 화면에서 초보 투자자가 관심 종목과 주요 지수 정보를 쉽게 찾는지 검증하고자 함.',
  testUiNamePlaceholder:
    '테스트 이름을 입력해주세요. (예: Npay 증권 홈 화면의 종목 탐색 영역 직관성 및 매수 진입 편의성 확인)',
  testUiDescriptionPlaceholder:
    '테스트 내용을 입력해주세요. (예: 초보 투자자가 홈 화면에서 관심 종목과 주요 지수를 빠르게 인지하고 매수 화면으로 이동할 수 있는지 검증하고자 함)',
  testAbNamePlaceholder:
    '테스트 이름을 입력해주세요. (예: 수익률 표시 방식 A/B, 매수 버튼 위치 및 강조 스타일 비교)',
  testAbDescriptionPlaceholder:
    '테스트 내용을 입력해주세요. (예: 초보 투자자가 두 가지 수익률 표시 안 중 어느 쪽이 더 이해하기 쉬운지, 실제 매수 의사결정에 도움이 되는지 비교하고자 함)',
};

export function getPersonaDomainCopy(user) {
  return isIndividualUser(user) ? FINANCE_COPY : TELECOM_COPY;
}

export function getTestCreateCopy(user) {
  const copy = getPersonaDomainCopy(user);
  return {
    ui: {
      namePlaceholder: copy.testUiNamePlaceholder,
      descriptionPlaceholder: copy.testUiDescriptionPlaceholder,
    },
    ab: {
      namePlaceholder: copy.testAbNamePlaceholder,
      descriptionPlaceholder: copy.testAbDescriptionPlaceholder,
    },
  };
}
